import React, { useState } from "react";
import { useDispatch } from "react-redux";
import * as api from "../../../redux/api/stickers/stickers_api";
import * as types from "../../../redux/constants/stickers_constants";
import { Button, Spinner } from "@material-tailwind/react";
import toast from "react-hot-toast";
import ConfirmPayment from "../../../common/shared/ConfirmPayment";

function StickerPay({ id, amount }) {
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);

  const dispatch = useDispatch();

  const handleOpen = () => setOpen((prev) => !prev);

  const handleLive = async (e) => {
    e.preventDefault();

    setLoading(true);

    try {
      const response = await api.stickerPayment(id);
      const { error, data } = response;

      if (error) {
        setLoading(false);
        setOpen(false);
        toast.error(error);
        dispatch({ type: types.STICKER_PAYMENT_FAILURE, payload: error });
      } else {
        const firstItem = data.sticker;
        const receiptUrl =
          firstItem?.receipt?.url ||
          firstItem?.new_receipt?.url ||
          firstItem?.receipts?.find((receipt) => receipt?.url)?.url ||
          data?.receipt?.url;

        if (receiptUrl) {
          window.location.href = receiptUrl;
        } else {
          toast.error("Payment link could not be generated. Please try again.");
        }

        setLoading(false);
        setOpen(false);
      }
    } catch (error) {
      setLoading(false);
      setOpen(false);
      console.log(error);
    }
  };

  return (
    <>
      <Button
        color="pink"
        className="flex item-center gap-3"
        onClick={handleOpen}
        disabled={loading}
      >
        {loading ? <Spinner color="white" /> : "Make Payment"}
      </Button>

      {open && (
        <ConfirmPayment
          open={open}
          setOpen={setOpen}
          title="Electronic"
          amount={amount || 0}
          loading={loading}
          handleConfirm={(e) => handleLive(e)}
          handleClose={handleOpen}
        />
      )}
    </>
  );
}

export default StickerPay;
